import React, { useEffect, useRef, useState } from "react";
import KebabIcon from "../../../../../assets/svg/icons/common/kebab";
import MailIcon from "../../../../../assets/svg/icons/common/mail";
import PhoneIcon from "../../../../../assets/svg/icons/common/phone";
import Avatar from "../../../../../components/Avatar/Avatar";
import useCommonStore from "../../../../../stores/common";
import Select from "./select";
import styles from "./styles.module.scss";
import moment from "moment";
import useOrganizationStore from "../../../../../stores/organization";

const ROLES = [
  { label: "Admin", value: "admin" },
  { label: "Agent", value: "agent" },
  { label: "Branch head", value: "branch head" },
  { label: "Office head", value: "office head" },
];

const AVAILABILITY = [
  { label: "Enabled", value: 0 },
  { label: "Disabled", value: 1 },
];

const getAvailabilityColor = (status) => {
  return status == 0 ? "#4CAF50" : "#CCCCCC";
};

const Member = ({
  member,
  onStatusChange,
  onResetPassword,
  onRemove,
  onEdit,
  viewType = "list",
}) => {
  const { id, name, phone_direct, email, role, disabled, joiningDate } = member;
  const isPCAdmin = useCommonStore((state) => state.isPCAdmin);
  const loginAs = useOrganizationStore((state) => state.loginAs);
  const [showActions, setShowActions] = useState(false);
  const actionsMenuRef = useRef(null);

  // ToDo: create a useDropdown/useClickOutside hook for reusability
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionsMenuRef.current &&
        !actionsMenuRef.current.contains(event.target)
      ) {
        setShowActions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${viewType === "card" ? styles.memberCard : styles.memberList}`}
    >
      <div className={styles.details}>
        <div className={styles.nameSection}>
          <div className={styles.name}>
            <Avatar text={name.charAt(0).toUpperCase()} />
            <h3>{name}</h3>
          </div>
          <div className={styles.actions}>
            {/* {isPCAdmin && ( */}
            <button className={styles.loginButton} onClick={() => loginAs(id)}>
              Login as
            </button>
            {/* )} */}
            <button
              className={styles.actionsButton}
              onClick={() => setShowActions(!showActions)}
            >
              <KebabIcon />
            </button>
          </div>
          {showActions && (
            <div className={styles.actionsMenu} ref={actionsMenuRef}>
              <button
                onClick={() => {
                  onEdit(member);
                }}
              >
                Edit
              </button>
              {/* {isPCAdmin && ( */}
              <button onClick={() => onResetPassword(id)}>
                Reset password
              </button>
              {/* )} */}
              <button
                className={styles.removeButton}
                onClick={() => onRemove(id)}
              >
                Remove user
              </button>
            </div>
          )}
        </div>
        <div className={styles.contactInfo}>
          <div className={styles.phone}>
            <PhoneIcon />
            {phone_direct ?? "-"}
          </div>
          <div className={styles.email}>
            <MailIcon />
            {email ?? "-"}
          </div>
        </div>

        <div className={styles.field}>
          <label>Role</label>
          <span>{ROLES.find((r) => r.value == role)?.label}</span>
        </div>

        {/* 
          ToDo: Implement role change later
          <Select
            label="Role"
            value={role}
            options={ROLES}
            onChange={onRoleChange}
          /> 
        */}
        <Select
          label="Availability"
          value={disabled}
          options={AVAILABILITY}
          onChange={(value) => onStatusChange(member, value)}
          indicatorColor={getAvailabilityColor(disabled)}
        />
        <div className={styles.field}>
          <label>Member ID</label>
          <span>{id}</span>
        </div>
        <div className={styles.field}>
          <label>Joining date</label>
          <span>{moment(joiningDate).format("MMM D, YYYY")}</span>
        </div>
        {/* 
          ToDo: Implement sub-organizations later
          <div className={styles.field}>
            <label>Sub-Organizations</label>
            <span>{subOrganizations || "-"}</span>
          </div> 
        */}
      </div>
    </div>
  );
};

export default Member;
